module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_6000.0c875721.png";